import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "./i18n"; // Initialize i18n before App
import App from "./App.tsx";
import "./index.css";
import { registerServiceWorker } from "./lib/pwa";
import { setupGlobalErrorHandling } from "./lib/errorLogger";
import { ErrorBoundary } from "./components/ErrorBoundary";

registerServiceWorker();
setupGlobalErrorHandling();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
